import { getErrorMessage } from '@juvare/widget-ui/Utils';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, AppBar, Box, Button, Dialog, IconButton, ToggleButton, ToggleButtonGroup, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { HtmlOutputHelp } from '../../HtmlOutput/HtmlOutputHelp';
import { TemplateOutput } from '../../WidgetFormContent/Components';
import { WidgetHandler } from '../../WidgetHandler';
import { walkWidgetConfigTree } from '../../walkWidgetConfigTree';
export const TemplateEditor = (props) => {
    var _a, _b, _c, _d;
    const [editorTab, setEditorTab] = React.useState('content');
    const [previewTab, setPreviewTab] = React.useState('preview');
    const [content, setContent] = React.useState((_a = props.template.content) !== null && _a !== void 0 ? _a : '');
    const [data, setData] = React.useState((_b = props.template.data) !== null && _b !== void 0 ? _b : '');
    const [dataTransform, setDataTransform] = React.useState((_c = props.template.dataTransform) !== null && _c !== void 0 ? _c : '');
    const [sample, setSample] = React.useState((_d = JSON.stringify(props.template.sample, undefined, '  ')) !== null && _d !== void 0 ? _d : '');
    let sampleError = '';
    let sampleJson;
    if (sample) {
        try {
            sampleJson = JSON.parse(sample);
        }
        catch (error) {
            sampleError = getErrorMessage(error);
        }
    }
    let dataTransformError = '';
    let dataTransformFunction;
    if (dataTransform) {
        try {
            dataTransformFunction = Function('"use strict"; return (function(data, handler) { ' + dataTransform + '; })')();
        }
        catch (error) {
            dataTransformError = getErrorMessage(error);
        }
    }
    const template = {
        content,
        data,
        dataTransform: dataTransformFunction ? dataTransform : undefined,
        sample: sampleJson,
    };
    return (React.createElement(Dialog, { fullScreen: true, open: props.open },
        React.createElement(Box, { sx: { width: '100%', height: '100%', overflow: 'hidden' } },
            React.createElement(AppBar, { sx: { position: 'relative' } },
                React.createElement(Toolbar, null,
                    React.createElement(IconButton, { edge: 'start', color: 'inherit', onClick: () => props.onCancel(), "aria-label": 'close', "data-test": 'close-button' },
                        React.createElement(CloseIcon, null)),
                    React.createElement(Typography, { sx: { ml: 2, flex: 1 }, variant: 'h6', component: 'div' }, "Template Editor"),
                    React.createElement(Button, { autoFocus: true, color: 'inherit', onClick: () => {
                            if (!dataTransformError && !sampleError) {
                                props.onSave(template);
                            }
                        }, "data-test": 'save-button' }, "Save"))),
            React.createElement(Box, { sx: { position: 'relative', minWidth: 920, height: '100%', overflow: 'hidden' } },
                React.createElement(Box, { sx: {
                        position: 'absolute',
                        boxSizing: 'border-box',
                        width: '50%',
                        height: '100%',
                        p: 2,
                        pr: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                    } },
                    React.createElement(Box, null,
                        React.createElement(ToggleButtonGroup, { color: 'primary', value: editorTab, exclusive: true, onChange: (event, editorTab) => {
                                if (editorTab) {
                                    setEditorTab(editorTab);
                                }
                            } },
                            React.createElement(ToggleButton, { value: 'content', "data-test": 'content-button' }, "Content"),
                            React.createElement(ToggleButton, { value: 'data', "data-test": 'data-button' }, "Data"),
                            React.createElement(ToggleButton, { value: 'dataTransform', "data-test": 'data-transform-button' }, "Data Transform"),
                            React.createElement(ToggleButton, { value: 'sample', "data-test": 'sample-button' }, "Sample"))),
                    React.createElement(TextEditor, { visible: editorTab === 'content', value: content, onChange: setContent, "data-test": 'content-textarea' }),
                    React.createElement(DataEditor, { visible: editorTab === 'data', value: data, onChange: setData, props: props.props, "data-test": 'data-input' }),
                    React.createElement(TextEditor, { visible: editorTab === 'dataTransform', value: dataTransform, onChange: setDataTransform, "data-test": 'data-transform-textarea' }),
                    React.createElement(TextEditor, { visible: editorTab === 'sample', value: sample, onChange: setSample, "data-test": 'sample-textarea' })),
                React.createElement(Box, { sx: {
                        position: 'absolute',
                        boxSizing: 'border-box',
                        width: '50%',
                        height: '100%',
                        left: '50%',
                        p: 2,
                        pl: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                    } },
                    React.createElement(Box, null,
                        React.createElement(ToggleButtonGroup, { color: 'primary', value: previewTab, exclusive: true, onChange: (event, previewTab) => {
                                if (previewTab) {
                                    setPreviewTab(previewTab);
                                }
                            } },
                            React.createElement(ToggleButton, { value: 'preview', "data-test": 'preview-button' }, "Preview"),
                            React.createElement(ToggleButton, { value: 'helpHtml', "data-test": 'help-html-button' }, "Help With HTML"),
                            React.createElement(ToggleButton, { value: 'helpTemplate', "data-test": 'help-template-button' }, "Help With Templating"))),
                    dataTransformError && React.createElement(Alert, { severity: 'error' },
                        "Data Transform Error - ",
                        dataTransformError),
                    sampleError && React.createElement(Alert, { severity: 'error' },
                        "Sample Error - ",
                        sampleError),
                    previewTab === 'preview' && (React.createElement(Typography, { component: 'div', "data-test": 'preview' },
                        React.createElement(TemplateOutput, { template: template, props: props.props, editMode: true }))),
                    previewTab === 'helpHtml' && React.createElement(HelpHtml, null),
                    previewTab === 'helpTemplate' && React.createElement(HelpTemplate, null))))));
};
const TextEditor = (props) => {
    return (React.createElement("textarea", { style: {
            flex: '1 0 0',
            display: props.visible ? 'block' : 'none',
            boxSizing: 'border-box',
            padding: 4,
            border: '1px solid rgba(0, 0, 0, 0.5)',
            outline: 'none',
            resize: 'none',
            fontFamily: 'monospace',
            fontSize: '14px',
        }, autoCapitalize: 'off', autoComplete: 'off', autoCorrect: 'off', spellCheck: false, value: props.value, onChange: (event) => props.onChange(event.target.value), "data-test": props['data-test'] }));
};
const DataEditor = (props) => {
    var _a;
    const [selectorInfo, setSelectorInfo] = React.useState();
    React.useEffect(() => {
        setSelectorInfo(calculateSelectorInfo(props.value, props.props));
    }, [props.value, props.props]);
    return (React.createElement("div", { style: { flex: '1 0 0', display: props.visible ? 'flex' : 'none', flexDirection: 'column', gap: 2 } },
        React.createElement("input", { type: 'text', style: {
                boxSizing: 'border-box',
                padding: 8,
                border: '1px solid rgba(0, 0, 0, 0.5)',
                outline: 'none',
                resize: 'none',
                fontFamily: 'monospace',
                fontSize: '22px',
            }, autoCapitalize: 'off', autoComplete: 'off', autoCorrect: 'off', spellCheck: false, value: props.value, onChange: (event) => props.onChange(event.target.value), "data-test": props['data-test'] }),
        selectorInfo && (React.createElement("div", { style: { flex: '1 0 0', overflow: 'auto' } },
            React.createElement(Typography, { sx: { pb: 2 } }, selectorInfo.info),
            selectorInfo.parent != null && (React.createElement(Box, { pb: 2 },
                React.createElement(Typography, null, "Parent:"),
                React.createElement(ClickableSelector, { value: (_a = selectorInfo === null || selectorInfo === void 0 ? void 0 : selectorInfo.parent) !== null && _a !== void 0 ? _a : '', onClick: props.onChange }))),
            selectorInfo.children.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement(Typography, null, "Children:"),
                selectorInfo.children.map((childSelector) => (React.createElement(ClickableSelector, { key: childSelector, value: childSelector, onClick: props.onChange })))))))));
};
const ClickableSelector = ({ value, onClick }) => {
    return (React.createElement(Box, { sx: {
            padding: '2px',
            cursor: 'pointer',
            fontFamily: 'monospace',
            fontSize: '14px',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.1)' },
        }, onClick: () => onClick(value) }, value || '(this)'));
};
function calculateSelectorInfo(start, props) {
    let handler = new WidgetHandler(props);
    if (start) {
        handler = handler.select(start);
    }
    if (handler) {
        const selectors = [];
        walkWidgetConfigTree(handler.config, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        handler.props.widgets, (config, widget, param) => {
            if (config === (handler === null || handler === void 0 ? void 0 : handler.config)) {
                return param;
            }
            if (config.key) {
                const selector = (param ? param + '/' : '') + config.key;
                if (!selectors.includes(selector)) {
                    selectors.push(selector);
                }
                return selector;
            }
            else {
                return param;
            }
        }, start !== '/' ? start : '');
        let parent = start;
        if (!parent) {
            parent = '^';
        }
        else {
            const i = parent.lastIndexOf('/');
            if (i !== -1) {
                parent = parent.substring(0, i);
            }
            else if (handler.up() !== handler) {
                if (/\^+/g.test(parent)) {
                    parent += '^';
                }
                else {
                    parent = '';
                }
            }
        }
        if (parent === start) {
            parent = undefined;
        }
        return {
            info: 'Component found, type: ' + handler.config.type + (handler.config.label ? ', label: ' + handler.config.label : ''),
            parent: parent,
            children: selectors,
        };
    }
    else {
        return { info: 'Component not found', children: [] };
    }
}
const HelpHtml = () => {
    return (React.createElement(Box, { sx: { flex: '1 0 0', overflow: 'auto' } },
        React.createElement(HtmlOutputHelp, null)));
};
const exampleValueFunction = `
Form JSON:
{
  "type": "form",
  "children": [
    {
      "type": "form.radio",
      "key": "gender",
      "label": "Gender",
      "values": [
        { "value": "f", "label": "Female" },
        { "value": "m", "label": "Male" }
      ]
    }
  ]
}

To render selected label of the gender component do:
<p>Selected gender: {{value "^gender"}}</p>
`.trim();
const HelpTemplate = () => {
    return (React.createElement(Box, { sx: { flex: '1 0 0', overflow: 'auto' } },
        React.createElement("p", null, "Help Template"),
        React.createElement("p", null, "Examples:"),
        React.createElement("ul", null,
            React.createElement("li", null,
                "Show component value as a label:",
                React.createElement("pre", null, exampleValueFunction)))));
};
